import { render, staticRenderFns } from "./userCoinDetail.vue?vue&type=template&id=db7e82a0&lang=html"
import script from "./userCoinDetail.vue?vue&type=script&lang=js"
export * from "./userCoinDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports